import { Component, OnInit } from '@angular/core';
import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TenantsButtonRendererComponent } from '../tenants-button-renderer/tenants-button-renderer.component';
import { AgGridTenantsSettings } from '../AgGridTenantsSettings';
//import { AgGridUserProjectsSettings } from 'projects/user/src/lib/project-list/AgGridUserProjectsSettings';
import { UserProjectsButtonRendererComponent } from 'projects/user/src/lib/project-list/user-projects-button-renderer/user-projects-button-renderer.component';
import { Router } from '@angular/router';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { catchError, map, of } from 'rxjs';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';

@Component({
  selector: 'select-tenant',
  templateUrl: './select-tenant.component.html',
  styleUrls: ['./select-tenant.component.css']
})
export class SelectTenantComponent implements OnInit {

  userTenants: TenantDto[] = [];
  selectTenantForm!: FormGroup;
  // isAuthenticated$!: Observable<boolean>;
  // isAuthenticated!: boolean;
  // _tenant!: string;
  // gridView = "squirrel";
  // squirreldbView!:string;
  // tenantdbView!:string;
  // _db!:string;

  // rowData1:TenantDto[] = [];
  rowData: TenantDto[] = [];
  // ds1!: IDatasource;
  ds!: IDatasource;

  gridApi!: GridApi;
  gridOptions!: GridOptions;
  // gridApi1!: GridApi;
  // gridOptions1!: GridOptions;
   frameworkComponents: any;
   filter!: GenericFilter;
  //aggridSettings!: AgGridUserProjectsSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  isAdmin = false;
  isAuthenticated = false;
  isToSelect = false;
  oneTenant = false;
  userId = "";
  user!: UserDto;
  isUserRetrieved = false;
  isConfirmed = false;
  emptyProjId = '00000000-0000-0000-0000-000000000000';

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private tenantService: TenantService,
    private userProfileService: UserProfileService,
    private accountService: AccountService,
    private oauthService: OAuthServiceService,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {

    // console.log("------------> select-tenant");
    // this.isAuthenticated$ = this.oauthService.isLoggedIn;
    // this.isAuthenticated$.subscribe({
    //   next: (isAuthenticated) => {
    //     this.isAuthenticated = isAuthenticated;
    //   }
    // });

    this.oauthService.userData.subscribe({
      next: (data: any) => {
        if (typeof data != undefined && data != null) {
          // console.log("------------> select-tenant user data1: ", data)
          this.isAuthenticated = true;
          this.userId = data.sub;
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin'){ 
              this.isAdmin = true;
            }
          });
        }
      }
    });

    if(this.isAuthenticated) {
      if (this.isAdmin)
        this.getAllTenants();
      else
        this.getUserTenants();
    }
}

showTenants(){
  // console.log("-------------> select-tenant - show tenant");
  if (this.oneTenant) {
    // console.log("-------------> select-tenant - one tenant");
    this.tenantService.currentTenantName = this.userTenants[0].name;
    //this.tenantService.currentTenantDb = this.userTenants[0].name;
    this.tenantService.currentTenantId = this.userTenants[0].id;

    (this.userTenants[0].name == this.tenantService.SystemManagerAbbreviation) ? this.router.navigate(['/', this.userTenants[0].name, 'manage-tenants']) : this.router.navigate(['/', this.userTenants[0].name, 'all-projects']);

  }
  else if (this.userTenants.length == 0) {
    this.notificationService.info(`${this.translate.data["INFO"]}`, `${this.translate.data["NOTENANTSRETRIEVED"]}`);
  }
  else
    this.isToSelect = true;  
}

getAllTenants() {
  this.tenantService.getTenants(new GenericFilter).subscribe({
  next:(tenantDtos:TenantDto[]) => { 
    tenantDtos.forEach((t: TenantDto) => {
      if (t.name != 'Basis'){
        this.userTenants.push(t)
      }
    });
    if(this.userTenants && this.isAdmin){
      const tenant: TenantDto = { id: '00000000-0000-0000-0000-000000000000', name: this.tenantService.SystemManagerAbbreviation, displayName: 'System Manager', isConfirmed: true}
      this.userTenants.push(tenant)
    }
    this.oneTenant = this.userTenants.length == 1; 
    this.isLoadingResults = false;
    this.showTenants();
  },
  error: (error: any) => {
    this.isLoadingResults = false;
    this.isRateLimitReached = true;
    this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
  }
});
}

getUserTenants() {
  this.tenantService.getUserTenants(new GenericFilter).subscribe({
  next:(tenantDtos:TenantDto[]) => { 
    tenantDtos.forEach((t: TenantDto) => {
      // console.log("------> select-tenant tenant=", t)
      if (t.name != 'Basis' && t.isConfirmed){
        this.userTenants.push(t)
      }
    });
    this.oneTenant = this.userTenants.length == 1; 
    this.isLoadingResults = false;
    this.showTenants();
  },
  error: (error: any) => {
    this.isLoadingResults = false;
    this.isRateLimitReached = true;
    this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["TENANTRETRIVALERROR"]}`)
  }
});
}
// createUserForm() {
  //   this.selectTenantForm = this.formBuilder.group({
  //     // name: [null, Validators.required],
  //     // permissions: ['']
  //   });
  // }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi.setDatasource(this.ds);
  }

  onRowClicked($event: any) {

    // console.log("onClick:", $event);
    // console.log(this.router.getCurrentNavigation)
    this.tenantService.currentTenantName = $event.name;
    //this.tenantService.currentTenantDb = $event.name;
    this.tenantService.currentTenantId = $event.id;

    if ($event.name != this.tenantService.SystemManagerAbbreviation) {
          // wenn Dashboard aktiv, zum "Dashboard"
          //($event.name == "sm") ? this.router.navigate(['/', $event.name, 'manage-tenants']) : this.router.navigate(['/', $event.name, 'dashboard']);
          // ansonsten nach "Projekten des Users in diesem Mandanten"
          this.router.navigate(['/', $event.name, 'all-projects']);

      //   },
      //   error: () => {
      //     this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["CREATESQUIRRELSESSIONERROR"]}`)
      //   }
      // })
    }
    else
      this.router.navigate(['/', $event.name, 'manage-tenants']);



    

    // this.dataSharingService.passProjectUrl($event.node.data.url);

    // localStorage.setItem('dbname', $event.node.data.name);
    // localStorage.setItem('project_id', $event.node.data.id);

    // if(this._db){
    //   this.projectGroupRolePermissionsService.getProjectUserPermissions($event.node.data.id).subscribe({
    //     next: (permissions: string[]) => {
    //       this.squirrelSessionRequest.projectPermissions = permissions
    //     }
    //   });
    // }
    // else{
    //   let db:string = this.tenantService.currentTenantName;
    //   this.tenantService.getProjectUserPermissions($event.node.data.id, db).subscribe({
    //     next: (permissions: string[]) => {
    //       this.squirrelSessionRequest.projectPermissions = permissions
    //     }
    //   });
    // }

  }

}
